import { JSX } from 'react';
import { IconCtaLeftAlignedCard } from '@ahc-digital/component-library';
import { CreateIconCTALeftAlignedCardModel } from './C33IconCTALeftAlignedCard.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C33IconCTALeftAlignedCardProps } from './C33IconCTALeftAlignedCard.types';

const Default = (props?: C33IconCTALeftAlignedCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaLeftAlignedCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      {...CreateIconCTALeftAlignedCardModel(props)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C33IconCTALeftAlignedCardProps>(Default);
